import { useTranslation } from "react-i18next";
import { blackTextLogo } from "../../assets/images/logos";
import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Notify from "../../utils/useNotify";
import axios from "axios";
import { useRefresh } from "../../utils/RefreshProvider";

export default function RegisterCheckout({ emailProp, sessionIdProp }) {
  const { t } = useTranslation();
  const { triggerRefresh } = useRefresh();
  const localhost = process.env.REACT_APP_LOCALHOST;
  const [isOpen, setIsOpen] = useState(false);
  const [username, setUsername] = useState('')
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState('')

  const closeModal = () => setIsOpen(false);
  const openModal = () => {
    setIsOpen(true);
    setEmail(emailProp);
  };

  const handleSignup = async (e) => {
    e.preventDefault();

    if (!username || !email || !password) {
      Notify('warning', t("login-fill-form-warning"));
      return;
    }
    try {
      const userData = { username, email, password, "session_id": sessionIdProp };
      const signupAction = await axios.post(`${localhost}register-checkout`, userData);
      localStorage.setItem('token', signupAction.data.token);
      localStorage.setItem('username', signupAction.data.username);
      localStorage.removeItem("session_id");
      Notify('success', t('s-register'));
      triggerRefresh();
      setTimeout(() => closeModal(), 300);
    } catch (err) {
      if (err.request && err.request.status === 422) {
        const errormsg = JSON.parse(err.request.response);
        if (errormsg.errors.username) {
          Notify('error', t(errormsg.errors.username[0]));
        }
        if (errormsg.errors.email) {
          Notify('error', t(errormsg.errors.email[0]));
        }
      } else {
        Notify('error', t('e-register'));
      }
    }
  };

  return (
    <>
      <button onClick={openModal} type="button" className="mb-2 block text-sm font-medium text-orange-500 hover:text-orange-600 hover:underline">{t("create-account")}</button>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0" >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95" >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <div className="w-full">
                    <div className="flex justify-center mx-auto">
                      <img loading="lazy"  className="w-auto h-7 sm:h-8" src={blackTextLogo} alt="logo" />
                    </div>

                    <div className="mt-6">
                      <label className="block mb-2 text-sm font-medium text-gray-600" htmlFor="Username">{t("username")}</label>
                      <input id="Username" value={username} onChange={(e) => setUsername(e.target.value)}
                        className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg focus:border-blue-400 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300" type="text" required />
                    </div>

                    <div className="mt-4">
                      <label className="block mb-2 text-sm font-medium text-gray-600" htmlFor="EmailAddress">{t("email")}</label>
                      <input id="EmailAddress" value={email} onChange={(e) => setEmail(e.target.value)}
                        className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg focus:border-blue-400 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300" type="email" required />
                    </div>

                    <div className="mt-4">
                      <label className="block mb-2 text-sm font-medium text-gray-600" htmlFor="psw">{t("password")}</label>
                      <input id="psw" value={password} onChange={(e) => setPassword(e.target.value)}
                        className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg focus:border-blue-400 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300" type="password" required />
                    </div>

                    <div className="mt-6 grid sm:grid-cols-2 gap-2">
                      <button onClick={handleSignup} type='button' className="col-span-1 px-6 py-3 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-gray-800 rounded-lg hover:bg-gray-700 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50">
                        {t("signup")}
                      </button>
                      <button type='button' onClick={closeModal} className="col-span-1 px-6 py-3 text-sm font-medium tracking-wide capitalize transition-colors duration-300 transform border bg-white hover:bg-gray-100 hover:text-black/80 text-black rounded-md focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50">
                        {t("cancel")}
                      </button>
                    </div>

                    <div className="flex items-center justify-between mt-4">
                      <span className="w-1/5 border-b md:w-1/4"></span>
                      <a href="/signin" className="text-xs text-gray-500 uppercase hover:underline">{t("or-signin")}</a>
                      <span className="w-1/5 border-b md:w-1/4"></span>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

    </>
  )
}
